"use strict";

var _slicedToArray = require("/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _toConsumableArray = require("/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _inherits = require("/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _defineProperty = require("/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/defineProperty.js");

var _regeneratorRuntime = require("/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/Users/zainmanji/Documents/Lazer/project-jz/node_modules/@babel/runtime/helpers/createClass.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intersection = exports.instanceof = exports.function = exports.enum = exports.effect = exports.discriminatedUnion = exports.date = exports.boolean = exports.bigint = exports.array = exports.any = exports.ZodFirstPartyTypeKind = exports.late = exports.ZodSchema = exports.Schema = exports.custom = exports.ZodNaN = exports.ZodDefault = exports.ZodNullable = exports.ZodOptional = exports.ZodTransformer = exports.ZodEffects = exports.ZodPromise = exports.ZodNativeEnum = exports.ZodEnum = exports.ZodLiteral = exports.ZodLazy = exports.ZodFunction = exports.ZodSet = exports.ZodMap = exports.ZodRecord = exports.ZodTuple = exports.ZodIntersection = exports.ZodDiscriminatedUnion = exports.ZodUnion = exports.ZodObject = exports.objectUtil = exports.ZodArray = exports.ZodVoid = exports.ZodNever = exports.ZodUnknown = exports.ZodAny = exports.ZodNull = exports.ZodUndefined = exports.ZodDate = exports.ZodBoolean = exports.ZodBigInt = exports.ZodNumber = exports.ZodString = exports.ZodType = void 0;
exports.void = exports.unknown = exports.union = exports.undefined = exports.tuple = exports.transformer = exports.string = exports.strictObject = exports.set = exports.record = exports.promise = exports.preprocess = exports.ostring = exports.optional = exports.onumber = exports.oboolean = exports.object = exports.number = exports.nullable = exports.null = exports.never = exports.nativeEnum = exports.nan = exports.map = exports.literal = exports.lazy = void 0;

var errorUtil_1 = require("./helpers/errorUtil");

var parseUtil_1 = require("./helpers/parseUtil");

var util_1 = require("./helpers/util");

var ZodError_1 = require("./ZodError");

var ParseInputLazyPath = /*#__PURE__*/function () {
  function ParseInputLazyPath(parent, value, path, key) {
    _classCallCheck(this, ParseInputLazyPath);

    this.parent = parent;
    this.data = value;
    this._path = path;
    this._key = key;
  }

  _createClass(ParseInputLazyPath, [{
    key: "path",
    get: function get() {
      return this._path.concat(this._key);
    }
  }]);

  return ParseInputLazyPath;
}();

var handleResult = function handleResult(ctx, result) {
  if ((0, parseUtil_1.isValid)(result)) {
    return {
      success: true,
      data: result.value
    };
  } else {
    if (!ctx.common.issues.length) {
      throw new Error("Validation failed but no issues detected.");
    }

    var error = new ZodError_1.ZodError(ctx.common.issues);
    return {
      success: false,
      error: error
    };
  }
};

function processCreateParams(params) {
  if (!params) return {};
  var errorMap = params.errorMap,
      invalid_type_error = params.invalid_type_error,
      required_error = params.required_error,
      description = params.description;

  if (errorMap && (invalid_type_error || required_error)) {
    throw new Error("Can't use \"invalid\" or \"required\" in conjunction with custom error map.");
  }

  if (errorMap) return {
    errorMap: errorMap,
    description: description
  };

  var customMap = function customMap(iss, ctx) {
    if (iss.code !== "invalid_type") return {
      message: ctx.defaultError
    };
    if (typeof ctx.data === "undefined" && required_error) return {
      message: required_error
    };
    if (params.invalid_type_error) return {
      message: params.invalid_type_error
    };
    return {
      message: ctx.defaultError
    };
  };

  return {
    errorMap: customMap,
    description: description
  };
}

var ZodType = /*#__PURE__*/function () {
  function ZodType(def) {
    _classCallCheck(this, ZodType);

    /** Alias of safeParseAsync */
    this.spa = this.safeParseAsync;
    this.superRefine = this._refinement;
    this._def = def;
    this.parse = this.parse.bind(this);
    this.safeParse = this.safeParse.bind(this);
    this.parseAsync = this.parseAsync.bind(this);
    this.safeParseAsync = this.safeParseAsync.bind(this);
    this.spa = this.spa.bind(this);
    this.refine = this.refine.bind(this);
    this.refinement = this.refinement.bind(this);
    this.superRefine = this.superRefine.bind(this);
    this.optional = this.optional.bind(this);
    this.nullable = this.nullable.bind(this);
    this.nullish = this.nullish.bind(this);
    this.array = this.array.bind(this);
    this.promise = this.promise.bind(this);
    this.or = this.or.bind(this);
    this.and = this.and.bind(this);
    this.transform = this.transform.bind(this);
    this.default = this.default.bind(this);
    this.describe = this.describe.bind(this);
    this.isNullable = this.isNullable.bind(this);
    this.isOptional = this.isOptional.bind(this);
  }

  _createClass(ZodType, [{
    key: "description",
    get: function get() {
      return this._def.description;
    }
  }, {
    key: "_getType",
    value: function _getType(input) {
      return (0, parseUtil_1.getParsedType)(input.data);
    }
  }, {
    key: "_getOrReturnCtx",
    value: function _getOrReturnCtx(input, ctx) {
      return ctx || {
        common: input.parent.common,
        data: input.data,
        parsedType: (0, parseUtil_1.getParsedType)(input.data),
        schemaErrorMap: this._def.errorMap,
        path: input.path,
        parent: input.parent
      };
    }
  }, {
    key: "_processInputParams",
    value: function _processInputParams(input) {
      return {
        status: new parseUtil_1.ParseStatus(),
        ctx: {
          common: input.parent.common,
          data: input.data,
          parsedType: (0, parseUtil_1.getParsedType)(input.data),
          schemaErrorMap: this._def.errorMap,
          path: input.path,
          parent: input.parent
        }
      };
    }
  }, {
    key: "_parseSync",
    value: function _parseSync(input) {
      var result = this._parse(input);

      if ((0, parseUtil_1.isAsync)(result)) {
        throw new Error("Synchronous parse encountered promise.");
      }

      return result;
    }
  }, {
    key: "_parseAsync",
    value: function _parseAsync(input) {
      var result = this._parse(input);

      return Promise.resolve(result);
    }
  }, {
    key: "parse",
    value: function parse(data, params) {
      var result = this.safeParse(data, params);
      if (result.success) return result.data;
      throw result.error;
    }
  }, {
    key: "safeParse",
    value: function safeParse(data, params) {
      var _a;

      var ctx = {
        common: {
          issues: [],
          async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
          contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
        },
        path: (params === null || params === void 0 ? void 0 : params.path) || [],
        schemaErrorMap: this._def.errorMap,
        parent: null,
        data: data,
        parsedType: (0, parseUtil_1.getParsedType)(data)
      };

      var result = this._parseSync({
        data: data,
        path: ctx.path,
        parent: ctx
      });

      return handleResult(ctx, result);
    }
  }, {
    key: "parseAsync",
    value: function () {
      var _parseAsync2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data, params) {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.safeParseAsync(data, params);

              case 2:
                result = _context.sent;

                if (!result.success) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", result.data);

              case 5:
                throw result.error;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function parseAsync(_x, _x2) {
        return _parseAsync2.apply(this, arguments);
      }

      return parseAsync;
    }()
  }, {
    key: "safeParseAsync",
    value: function () {
      var _safeParseAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data, params) {
        var ctx, maybeAsyncResult, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                ctx = {
                  common: {
                    issues: [],
                    contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                    async: true
                  },
                  path: (params === null || params === void 0 ? void 0 : params.path) || [],
                  schemaErrorMap: this._def.errorMap,
                  parent: null,
                  data: data,
                  parsedType: (0, parseUtil_1.getParsedType)(data)
                };
                maybeAsyncResult = this._parse({
                  data: data,
                  path: [],
                  parent: ctx
                });
                _context2.next = 4;
                return (0, parseUtil_1.isAsync)(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult);

              case 4:
                result = _context2.sent;
                return _context2.abrupt("return", handleResult(ctx, result));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function safeParseAsync(_x3, _x4) {
        return _safeParseAsync.apply(this, arguments);
      }

      return safeParseAsync;
    }()
  }, {
    key: "refine",
    value: function refine(check, message) {
      var getIssueProperties = function getIssueProperties(val) {
        if (typeof message === "string" || typeof message === "undefined") {
          return {
            message: message
          };
        } else if (typeof message === "function") {
          return message(val);
        } else {
          return message;
        }
      };

      return this._refinement(function (val, ctx) {
        var result = check(val);

        var setError = function setError() {
          return ctx.addIssue(_objectSpread({
            code: ZodError_1.ZodIssueCode.custom
          }, getIssueProperties(val)));
        };

        if (typeof Promise !== "undefined" && result instanceof Promise) {
          return result.then(function (data) {
            if (!data) {
              setError();
              return false;
            } else {
              return true;
            }
          });
        }

        if (!result) {
          setError();
          return false;
        } else {
          return true;
        }
      });
    }
  }, {
    key: "refinement",
    value: function refinement(check, refinementData) {
      return this._refinement(function (val, ctx) {
        if (!check(val)) {
          ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
          return false;
        } else {
          return true;
        }
      });
    }
  }, {
    key: "_refinement",
    value: function _refinement(refinement) {
      return new ZodEffects({
        schema: this,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect: {
          type: "refinement",
          refinement: refinement
        }
      });
    }
  }, {
    key: "optional",
    value: function optional() {
      "";
      "asdf";
      return ZodOptional.create(this);
    }
  }, {
    key: "nullable",
    value: function nullable() {
      return ZodNullable.create(this);
    }
  }, {
    key: "nullish",
    value: function nullish() {
      return this.optional().nullable();
    }
  }, {
    key: "array",
    value: function array() {
      return ZodArray.create(this);
    }
  }, {
    key: "promise",
    value: function promise() {
      return ZodPromise.create(this);
    }
  }, {
    key: "or",
    value: function or(option) {
      return ZodUnion.create([this, option]);
    }
  }, {
    key: "and",
    value: function and(incoming) {
      return ZodIntersection.create(this, incoming);
    }
  }, {
    key: "transform",
    value: function transform(_transform) {
      return new ZodEffects({
        schema: this,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect: {
          type: "transform",
          transform: _transform
        }
      });
    }
  }, {
    key: "default",
    value: function _default(def) {
      var defaultValueFunc = typeof def === "function" ? def : function () {
        return def;
      };
      return new ZodDefault({
        innerType: this,
        defaultValue: defaultValueFunc,
        typeName: ZodFirstPartyTypeKind.ZodDefault
      });
    }
  }, {
    key: "describe",
    value: function describe(description) {
      var This = this.constructor;
      return new This(_objectSpread(_objectSpread({}, this._def), {}, {
        description: description
      }));
    }
  }, {
    key: "isOptional",
    value: function isOptional() {
      return this.safeParse(undefined).success;
    }
  }, {
    key: "isNullable",
    value: function isNullable() {
      return this.safeParse(null).success;
    }
  }]);

  return ZodType;
}();

exports.ZodType = ZodType;
exports.Schema = ZodType;
exports.ZodSchema = ZodType;
var cuidRegex = /^c[^\s-]{8,}$/i;
var uuidRegex = /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i; // from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
// eslint-disable-next-line

var emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

var ZodString = /*#__PURE__*/function (_ZodType) {
  _inherits(ZodString, _ZodType);

  var _super = _createSuper(ZodString);

  function ZodString() {
    var _this;

    _classCallCheck(this, ZodString);

    _this = _super.apply(this, arguments);

    _this._regex = function (regex, validation, message) {
      return _this.refinement(function (data) {
        return regex.test(data);
      }, _objectSpread({
        validation: validation,
        code: ZodError_1.ZodIssueCode.invalid_string
      }, errorUtil_1.errorUtil.errToObj(message)));
    };
    /**
     * Deprecated.
     * Use z.string().min(1) instead.
     */


    _this.nonempty = function (message) {
      return _this.min(1, errorUtil_1.errorUtil.errToObj(message));
    };

    return _this;
  }

  _createClass(ZodString, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);

      if (parsedType !== parseUtil_1.ZodParsedType.string) {
        var _ctx = this._getOrReturnCtx(input);

        (0, parseUtil_1.addIssueToContext)(_ctx, {
          code: ZodError_1.ZodIssueCode.invalid_type,
          expected: parseUtil_1.ZodParsedType.string,
          received: _ctx.parsedType
        } //
        );
        return parseUtil_1.INVALID;
      }

      var status = new parseUtil_1.ParseStatus();
      var ctx = undefined;

      var _iterator = _createForOfIteratorHelper(this._def.checks),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var check = _step.value;

          if (check.kind === "min") {
            if (input.data.length < check.value) {
              ctx = this._getOrReturnCtx(input, ctx);
              (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.too_small,
                minimum: check.value,
                type: "string",
                inclusive: true,
                message: check.message
              });
              status.dirty();
            }
          } else if (check.kind === "max") {
            if (input.data.length > check.value) {
              ctx = this._getOrReturnCtx(input, ctx);
              (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.too_big,
                maximum: check.value,
                type: "string",
                inclusive: true,
                message: check.message
              });
              status.dirty();
            }
          } else if (check.kind === "email") {
            if (!emailRegex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              (0, parseUtil_1.addIssueToContext)(ctx, {
                validation: "email",
                code: ZodError_1.ZodIssueCode.invalid_string,
                message: check.message
              });
              status.dirty();
            }
          } else if (check.kind === "uuid") {
            if (!uuidRegex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              (0, parseUtil_1.addIssueToContext)(ctx, {
                validation: "uuid",
                code: ZodError_1.ZodIssueCode.invalid_string,
                message: check.message
              });
              status.dirty();
            }
          } else if (check.kind === "cuid") {
            if (!cuidRegex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              (0, parseUtil_1.addIssueToContext)(ctx, {
                validation: "cuid",
                code: ZodError_1.ZodIssueCode.invalid_string,
                message: check.message
              });
              status.dirty();
            }
          } else if (check.kind === "url") {
            try {
              new URL(input.data);
            } catch (_a) {
              ctx = this._getOrReturnCtx(input, ctx);
              (0, parseUtil_1.addIssueToContext)(ctx, {
                validation: "url",
                code: ZodError_1.ZodIssueCode.invalid_string,
                message: check.message
              });
              status.dirty();
            }
          } else if (check.kind === "regex") {
            check.regex.lastIndex = 0;
            var testResult = check.regex.test(input.data);

            if (!testResult) {
              ctx = this._getOrReturnCtx(input, ctx);
              (0, parseUtil_1.addIssueToContext)(ctx, {
                validation: "regex",
                code: ZodError_1.ZodIssueCode.invalid_string,
                message: check.message
              });
              status.dirty();
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return {
        status: status.value,
        value: input.data
      };
    }
  }, {
    key: "_addCheck",
    value: function _addCheck(check) {
      return new ZodString(_objectSpread(_objectSpread({}, this._def), {}, {
        checks: [].concat(_toConsumableArray(this._def.checks), [check])
      }));
    }
  }, {
    key: "email",
    value: function email(message) {
      return this._addCheck(_objectSpread({
        kind: "email"
      }, errorUtil_1.errorUtil.errToObj(message)));
    }
  }, {
    key: "url",
    value: function url(message) {
      return this._addCheck(_objectSpread({
        kind: "url"
      }, errorUtil_1.errorUtil.errToObj(message)));
    }
  }, {
    key: "uuid",
    value: function uuid(message) {
      return this._addCheck(_objectSpread({
        kind: "uuid"
      }, errorUtil_1.errorUtil.errToObj(message)));
    }
  }, {
    key: "cuid",
    value: function cuid(message) {
      return this._addCheck(_objectSpread({
        kind: "cuid"
      }, errorUtil_1.errorUtil.errToObj(message)));
    }
  }, {
    key: "regex",
    value: function regex(_regex, message) {
      return this._addCheck(_objectSpread({
        kind: "regex",
        regex: _regex
      }, errorUtil_1.errorUtil.errToObj(message)));
    }
  }, {
    key: "min",
    value: function min(minLength, message) {
      return this._addCheck(_objectSpread({
        kind: "min",
        value: minLength
      }, errorUtil_1.errorUtil.errToObj(message)));
    }
  }, {
    key: "max",
    value: function max(maxLength, message) {
      return this._addCheck(_objectSpread({
        kind: "max",
        value: maxLength
      }, errorUtil_1.errorUtil.errToObj(message)));
    }
  }, {
    key: "length",
    value: function length(len, message) {
      return this.min(len, message).max(len, message);
    }
  }, {
    key: "isEmail",
    get: function get() {
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "email";
      });
    }
  }, {
    key: "isURL",
    get: function get() {
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "url";
      });
    }
  }, {
    key: "isUUID",
    get: function get() {
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "uuid";
      });
    }
  }, {
    key: "isCUID",
    get: function get() {
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "cuid";
      });
    }
  }, {
    key: "minLength",
    get: function get() {
      var min = -Infinity;

      this._def.checks.map(function (ch) {
        if (ch.kind === "min") {
          if (min === null || ch.value > min) {
            min = ch.value;
          }
        }
      });

      return min;
    }
  }, {
    key: "maxLength",
    get: function get() {
      var max = null;

      this._def.checks.map(function (ch) {
        if (ch.kind === "max") {
          if (max === null || ch.value < max) {
            max = ch.value;
          }
        }
      });

      return max;
    }
  }]);

  return ZodString;
}(ZodType);

exports.ZodString = ZodString;

ZodString.create = function (params) {
  return new ZodString(_objectSpread({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodString
  }, processCreateParams(params)));
}; // https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034


function floatSafeRemainder(val, step) {
  var valDecCount = (val.toString().split(".")[1] || "").length;
  var stepDecCount = (step.toString().split(".")[1] || "").length;
  var decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
  var valInt = parseInt(val.toFixed(decCount).replace(".", ""));
  var stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
  return valInt % stepInt / Math.pow(10, decCount);
}

var ZodNumber = /*#__PURE__*/function (_ZodType2) {
  _inherits(ZodNumber, _ZodType2);

  var _super2 = _createSuper(ZodNumber);

  function ZodNumber() {
    var _this2;

    _classCallCheck(this, ZodNumber);

    _this2 = _super2.apply(this, arguments);
    _this2.min = _this2.gte;
    _this2.max = _this2.lte;
    _this2.step = _this2.multipleOf;
    return _this2;
  }

  _createClass(ZodNumber, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);

      if (parsedType !== parseUtil_1.ZodParsedType.number) {
        var _ctx2 = this._getOrReturnCtx(input);

        (0, parseUtil_1.addIssueToContext)(_ctx2, {
          code: ZodError_1.ZodIssueCode.invalid_type,
          expected: parseUtil_1.ZodParsedType.number,
          received: _ctx2.parsedType
        });
        return parseUtil_1.INVALID;
      }

      var ctx = undefined;
      var status = new parseUtil_1.ParseStatus();

      var _iterator2 = _createForOfIteratorHelper(this._def.checks),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var check = _step2.value;

          if (check.kind === "int") {
            if (!util_1.util.isInteger(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.invalid_type,
                expected: "integer",
                received: "float",
                message: check.message
              });
              status.dirty();
            }
          } else if (check.kind === "min") {
            var tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;

            if (tooSmall) {
              ctx = this._getOrReturnCtx(input, ctx);
              (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.too_small,
                minimum: check.value,
                type: "number",
                inclusive: check.inclusive,
                message: check.message
              });
              status.dirty();
            }
          } else if (check.kind === "max") {
            var tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;

            if (tooBig) {
              ctx = this._getOrReturnCtx(input, ctx);
              (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.too_big,
                maximum: check.value,
                type: "number",
                inclusive: check.inclusive,
                message: check.message
              });
              status.dirty();
            }
          } else if (check.kind === "multipleOf") {
            if (floatSafeRemainder(input.data, check.value) !== 0) {
              ctx = this._getOrReturnCtx(input, ctx);
              (0, parseUtil_1.addIssueToContext)(ctx, {
                code: ZodError_1.ZodIssueCode.not_multiple_of,
                multipleOf: check.value,
                message: check.message
              });
              status.dirty();
            }
          } else {
            util_1.util.assertNever(check);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return {
        status: status.value,
        value: input.data
      };
    }
  }, {
    key: "gte",
    value: function gte(value, message) {
      return this.setLimit("min", value, true, errorUtil_1.errorUtil.toString(message));
    }
  }, {
    key: "gt",
    value: function gt(value, message) {
      return this.setLimit("min", value, false, errorUtil_1.errorUtil.toString(message));
    }
  }, {
    key: "lte",
    value: function lte(value, message) {
      return this.setLimit("max", value, true, errorUtil_1.errorUtil.toString(message));
    }
  }, {
    key: "lt",
    value: function lt(value, message) {
      return this.setLimit("max", value, false, errorUtil_1.errorUtil.toString(message));
    }
  }, {
    key: "setLimit",
    value: function setLimit(kind, value, inclusive, message) {
      return new ZodNumber(_objectSpread(_objectSpread({}, this._def), {}, {
        checks: [].concat(_toConsumableArray(this._def.checks), [{
          kind: kind,
          value: value,
          inclusive: inclusive,
          message: errorUtil_1.errorUtil.toString(message)
        }])
      }));
    }
  }, {
    key: "_addCheck",
    value: function _addCheck(check) {
      return new ZodNumber(_objectSpread(_objectSpread({}, this._def), {}, {
        checks: [].concat(_toConsumableArray(this._def.checks), [check])
      }));
    }
  }, {
    key: "int",
    value: function int(message) {
      return this._addCheck({
        kind: "int",
        message: errorUtil_1.errorUtil.toString(message)
      });
    }
  }, {
    key: "positive",
    value: function positive(message) {
      return this._addCheck({
        kind: "min",
        value: 0,
        inclusive: false,
        message: errorUtil_1.errorUtil.toString(message)
      });
    }
  }, {
    key: "negative",
    value: function negative(message) {
      return this._addCheck({
        kind: "max",
        value: 0,
        inclusive: false,
        message: errorUtil_1.errorUtil.toString(message)
      });
    }
  }, {
    key: "nonpositive",
    value: function nonpositive(message) {
      return this._addCheck({
        kind: "max",
        value: 0,
        inclusive: true,
        message: errorUtil_1.errorUtil.toString(message)
      });
    }
  }, {
    key: "nonnegative",
    value: function nonnegative(message) {
      return this._addCheck({
        kind: "min",
        value: 0,
        inclusive: true,
        message: errorUtil_1.errorUtil.toString(message)
      });
    }
  }, {
    key: "multipleOf",
    value: function multipleOf(value, message) {
      return this._addCheck({
        kind: "multipleOf",
        value: value,
        message: errorUtil_1.errorUtil.toString(message)
      });
    }
  }, {
    key: "minValue",
    get: function get() {
      var min = null;

      var _iterator3 = _createForOfIteratorHelper(this._def.checks),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var ch = _step3.value;

          if (ch.kind === "min") {
            if (min === null || ch.value > min) min = ch.value;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return min;
    }
  }, {
    key: "maxValue",
    get: function get() {
      var max = null;

      var _iterator4 = _createForOfIteratorHelper(this._def.checks),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var ch = _step4.value;

          if (ch.kind === "max") {
            if (max === null || ch.value < max) max = ch.value;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return max;
    }
  }, {
    key: "isInt",
    get: function get() {
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "int";
      });
    }
  }]);

  return ZodNumber;
}(ZodType);

exports.ZodNumber = ZodNumber;

ZodNumber.create = function (params) {
  return new ZodNumber(_objectSpread({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodNumber
  }, processCreateParams(params)));
};

var ZodBigInt = /*#__PURE__*/function (_ZodType3) {
  _inherits(ZodBigInt, _ZodType3);

  var _super3 = _createSuper(ZodBigInt);

  function ZodBigInt() {
    _classCallCheck(this, ZodBigInt);

    return _super3.apply(this, arguments);
  }

  _createClass(ZodBigInt, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);

      if (parsedType !== parseUtil_1.ZodParsedType.bigint) {
        var ctx = this._getOrReturnCtx(input);

        (0, parseUtil_1.addIssueToContext)(ctx, {
          code: ZodError_1.ZodIssueCode.invalid_type,
          expected: parseUtil_1.ZodParsedType.bigint,
          received: ctx.parsedType
        });
        return parseUtil_1.INVALID;
      }

      return (0, parseUtil_1.OK)(input.data);
    }
  }]);

  return ZodBigInt;
}(ZodType);

exports.ZodBigInt = ZodBigInt;

ZodBigInt.create = function (params) {
  return new ZodBigInt(_objectSpread({
    typeName: ZodFirstPartyTypeKind.ZodBigInt
  }, processCreateParams(params)));
};

var ZodBoolean = /*#__PURE__*/function (_ZodType4) {
  _inherits(ZodBoolean, _ZodType4);

  var _super4 = _createSuper(ZodBoolean);

  function ZodBoolean() {
    _classCallCheck(this, ZodBoolean);

    return _super4.apply(this, arguments);
  }

  _createClass(ZodBoolean, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);

      if (parsedType !== parseUtil_1.ZodParsedType.boolean) {
        var ctx = this._getOrReturnCtx(input);

        (0, parseUtil_1.addIssueToContext)(ctx, {
          code: ZodError_1.ZodIssueCode.invalid_type,
          expected: parseUtil_1.ZodParsedType.boolean,
          received: ctx.parsedType
        });
        return parseUtil_1.INVALID;
      }

      return (0, parseUtil_1.OK)(input.data);
    }
  }]);

  return ZodBoolean;
}(ZodType);

exports.ZodBoolean = ZodBoolean;

ZodBoolean.create = function (params) {
  return new ZodBoolean(_objectSpread({
    typeName: ZodFirstPartyTypeKind.ZodBoolean
  }, processCreateParams(params)));
};

var ZodDate = /*#__PURE__*/function (_ZodType5) {
  _inherits(ZodDate, _ZodType5);

  var _super5 = _createSuper(ZodDate);

  function ZodDate() {
    _classCallCheck(this, ZodDate);

    return _super5.apply(this, arguments);
  }

  _createClass(ZodDate, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);

      if (parsedType !== parseUtil_1.ZodParsedType.date) {
        var ctx = this._getOrReturnCtx(input);

        (0, parseUtil_1.addIssueToContext)(ctx, {
          code: ZodError_1.ZodIssueCode.invalid_type,
          expected: parseUtil_1.ZodParsedType.date,
          received: ctx.parsedType
        });
        return parseUtil_1.INVALID;
      }

      if (isNaN(input.data.getTime())) {
        var _ctx3 = this._getOrReturnCtx(input);

        (0, parseUtil_1.addIssueToContext)(_ctx3, {
          code: ZodError_1.ZodIssueCode.invalid_date
        });
        return parseUtil_1.INVALID;
      }

      return {
        status: "valid",
        value: new Date(input.data.getTime())
      };
    }
  }]);

  return ZodDate;
}(ZodType);

exports.ZodDate = ZodDate;

ZodDate.create = function (params) {
  return new ZodDate(_objectSpread({
    typeName: ZodFirstPartyTypeKind.ZodDate
  }, processCreateParams(params)));
};

var ZodUndefined = /*#__PURE__*/function (_ZodType6) {
  _inherits(ZodUndefined, _ZodType6);

  var _super6 = _createSuper(ZodUndefined);

  function ZodUndefined() {
    _classCallCheck(this, ZodUndefined);

    return _super6.apply(this, arguments);
  }

  _createClass(ZodUndefined, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);

      if (parsedType !== parseUtil_1.ZodParsedType.undefined) {
        var ctx = this._getOrReturnCtx(input);

        (0, parseUtil_1.addIssueToContext)(ctx, {
          code: ZodError_1.ZodIssueCode.invalid_type,
          expected: parseUtil_1.ZodParsedType.undefined,
          received: ctx.parsedType
        });
        return parseUtil_1.INVALID;
      }

      return (0, parseUtil_1.OK)(input.data);
    }
  }]);

  return ZodUndefined;
}(ZodType);

exports.ZodUndefined = ZodUndefined;

ZodUndefined.create = function (params) {
  return new ZodUndefined(_objectSpread({
    typeName: ZodFirstPartyTypeKind.ZodUndefined
  }, processCreateParams(params)));
};

var ZodNull = /*#__PURE__*/function (_ZodType7) {
  _inherits(ZodNull, _ZodType7);

  var _super7 = _createSuper(ZodNull);

  function ZodNull() {
    _classCallCheck(this, ZodNull);

    return _super7.apply(this, arguments);
  }

  _createClass(ZodNull, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);

      if (parsedType !== parseUtil_1.ZodParsedType.null) {
        var ctx = this._getOrReturnCtx(input);

        (0, parseUtil_1.addIssueToContext)(ctx, {
          code: ZodError_1.ZodIssueCode.invalid_type,
          expected: parseUtil_1.ZodParsedType.null,
          received: ctx.parsedType
        });
        return parseUtil_1.INVALID;
      }

      return (0, parseUtil_1.OK)(input.data);
    }
  }]);

  return ZodNull;
}(ZodType);

exports.ZodNull = ZodNull;

ZodNull.create = function (params) {
  return new ZodNull(_objectSpread({
    typeName: ZodFirstPartyTypeKind.ZodNull
  }, processCreateParams(params)));
};

var ZodAny = /*#__PURE__*/function (_ZodType8) {
  _inherits(ZodAny, _ZodType8);

  var _super8 = _createSuper(ZodAny);

  function ZodAny() {
    var _this3;

    _classCallCheck(this, ZodAny);

    _this3 = _super8.apply(this, arguments); // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.

    _this3._any = true;
    return _this3;
  }

  _createClass(ZodAny, [{
    key: "_parse",
    value: function _parse(input) {
      return (0, parseUtil_1.OK)(input.data);
    }
  }]);

  return ZodAny;
}(ZodType);

exports.ZodAny = ZodAny;

ZodAny.create = function (params) {
  return new ZodAny(_objectSpread({
    typeName: ZodFirstPartyTypeKind.ZodAny
  }, processCreateParams(params)));
};

var ZodUnknown = /*#__PURE__*/function (_ZodType9) {
  _inherits(ZodUnknown, _ZodType9);

  var _super9 = _createSuper(ZodUnknown);

  function ZodUnknown() {
    var _this4;

    _classCallCheck(this, ZodUnknown);

    _this4 = _super9.apply(this, arguments); // required

    _this4._unknown = true;
    return _this4;
  }

  _createClass(ZodUnknown, [{
    key: "_parse",
    value: function _parse(input) {
      return (0, parseUtil_1.OK)(input.data);
    }
  }]);

  return ZodUnknown;
}(ZodType);

exports.ZodUnknown = ZodUnknown;

ZodUnknown.create = function (params) {
  return new ZodUnknown(_objectSpread({
    typeName: ZodFirstPartyTypeKind.ZodUnknown
  }, processCreateParams(params)));
};

var ZodNever = /*#__PURE__*/function (_ZodType10) {
  _inherits(ZodNever, _ZodType10);

  var _super10 = _createSuper(ZodNever);

  function ZodNever() {
    _classCallCheck(this, ZodNever);

    return _super10.apply(this, arguments);
  }

  _createClass(ZodNever, [{
    key: "_parse",
    value: function _parse(input) {
      var ctx = this._getOrReturnCtx(input);

      (0, parseUtil_1.addIssueToContext)(ctx, {
        code: ZodError_1.ZodIssueCode.invalid_type,
        expected: parseUtil_1.ZodParsedType.never,
        received: ctx.parsedType
      });
      return parseUtil_1.INVALID;
    }
  }]);

  return ZodNever;
}(ZodType);

exports.ZodNever = ZodNever;

ZodNever.create = function (params) {
  return new ZodNever(_objectSpread({
    typeName: ZodFirstPartyTypeKind.ZodNever
  }, processCreateParams(params)));
};

var ZodVoid = /*#__PURE__*/function (_ZodType11) {
  _inherits(ZodVoid, _ZodType11);

  var _super11 = _createSuper(ZodVoid);

  function ZodVoid() {
    _classCallCheck(this, ZodVoid);

    return _super11.apply(this, arguments);
  }

  _createClass(ZodVoid, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);

      if (parsedType !== parseUtil_1.ZodParsedType.undefined) {
        var ctx = this._getOrReturnCtx(input);

        (0, parseUtil_1.addIssueToContext)(ctx, {
          code: ZodError_1.ZodIssueCode.invalid_type,
          expected: parseUtil_1.ZodParsedType.void,
          received: ctx.parsedType
        });
        return parseUtil_1.INVALID;
      }

      return (0, parseUtil_1.OK)(input.data);
    }
  }]);

  return ZodVoid;
}(ZodType);

exports.ZodVoid = ZodVoid;

ZodVoid.create = function (params) {
  return new ZodVoid(_objectSpread({
    typeName: ZodFirstPartyTypeKind.ZodVoid
  }, processCreateParams(params)));
};

var ZodArray = /*#__PURE__*/function (_ZodType12) {
  _inherits(ZodArray, _ZodType12);

  var _super12 = _createSuper(ZodArray);

  function ZodArray() {
    _classCallCheck(this, ZodArray);

    return _super12.apply(this, arguments);
  }

  _createClass(ZodArray, [{
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa = this._processInputParams(input),
          ctx = _this$_processInputPa.ctx,
          status = _this$_processInputPa.status;

      var def = this._def;

      if (ctx.parsedType !== parseUtil_1.ZodParsedType.array) {
        (0, parseUtil_1.addIssueToContext)(ctx, {
          code: ZodError_1.ZodIssueCode.invalid_type,
          expected: parseUtil_1.ZodParsedType.array,
          received: ctx.parsedType
        });
        return parseUtil_1.INVALID;
      }

      if (def.minLength !== null) {
        if (ctx.data.length < def.minLength.value) {
          (0, parseUtil_1.addIssueToContext)(ctx, {
            code: ZodError_1.ZodIssueCode.too_small,
            minimum: def.minLength.value,
            type: "array",
            inclusive: true,
            message: def.minLength.message
          });
          status.dirty();
        }
      }

      if (def.maxLength !== null) {
        if (ctx.data.length > def.maxLength.value) {
          (0, parseUtil_1.addIssueToContext)(ctx, {
            code: ZodError_1.ZodIssueCode.too_big,
            maximum: def.maxLength.value,
            type: "array",
            inclusive: true,
            message: def.maxLength.message
          });
          status.dirty();
        }
      }

      if (ctx.common.async) {
        return Promise.all(ctx.data.map(function (item, i) {
          return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then(function (result) {
          return parseUtil_1.ParseStatus.mergeArray(status, result);
        });
      }

      var result = ctx.data.map(function (item, i) {
        return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
      });
      return parseUtil_1.ParseStatus.mergeArray(status, result);
    }
  }, {
    key: "element",
    get: function get() {
      return this._def.type;
    }
  }, {
    key: "min",
    value: function min(minLength, message) {
      return new ZodArray(_objectSpread(_objectSpread({}, this._def), {}, {
        minLength: {
          value: minLength,
          message: errorUtil_1.errorUtil.toString(message)
        }
      }));
    }
  }, {
    key: "max",
    value: function max(maxLength, message) {
      return new ZodArray(_objectSpread(_objectSpread({}, this._def), {}, {
        maxLength: {
          value: maxLength,
          message: errorUtil_1.errorUtil.toString(message)
        }
      }));
    }
  }, {
    key: "length",
    value: function length(len, message) {
      return this.min(len, message).max(len, message);
    }
  }, {
    key: "nonempty",
    value: function nonempty(message) {
      return this.min(1, message);
    }
  }]);

  return ZodArray;
}(ZodType);

exports.ZodArray = ZodArray;

ZodArray.create = function (schema, params) {
  return new ZodArray(_objectSpread({
    type: schema,
    minLength: null,
    maxLength: null,
    typeName: ZodFirstPartyTypeKind.ZodArray
  }, processCreateParams(params)));
}; /////////////////////////////////////////
/////////////////////////////////////////
//////////                     //////////
//////////      ZodObject      //////////
//////////                     //////////
/////////////////////////////////////////
/////////////////////////////////////////


var objectUtil;

(function (objectUtil) {
  objectUtil.mergeShapes = function (first, second) {
    return _objectSpread(_objectSpread({}, first), second);
  };
})(objectUtil = exports.objectUtil || (exports.objectUtil = {}));

var AugmentFactory = function AugmentFactory(def) {
  return function (augmentation) {
    return new ZodObject(_objectSpread(_objectSpread({}, def), {}, {
      shape: function shape() {
        return _objectSpread(_objectSpread({}, def.shape()), augmentation);
      }
    }));
  };
};

function deepPartialify(schema) {
  if (schema instanceof ZodObject) {
    var newShape = {};

    for (var key in schema.shape) {
      var fieldSchema = schema.shape[key];
      newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
    }

    return new ZodObject(_objectSpread(_objectSpread({}, schema._def), {}, {
      shape: function shape() {
        return newShape;
      }
    }));
  } else if (schema instanceof ZodArray) {
    return ZodArray.create(deepPartialify(schema.element));
  } else if (schema instanceof ZodOptional) {
    return ZodOptional.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodNullable) {
    return ZodNullable.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodTuple) {
    return ZodTuple.create(schema.items.map(function (item) {
      return deepPartialify(item);
    }));
  } else {
    return schema;
  }
}

var ZodObject = /*#__PURE__*/function (_ZodType13) {
  _inherits(ZodObject, _ZodType13);

  var _super13 = _createSuper(ZodObject);

  function ZodObject() {
    var _this5;

    _classCallCheck(this, ZodObject);

    _this5 = _super13.apply(this, arguments);
    _this5._cached = null;
    /**
     * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
     * If you want to pass through unknown properties, use `.passthrough()` instead.
     */

    _this5.nonstrict = _this5.passthrough;
    _this5.augment = AugmentFactory(_this5._def);
    _this5.extend = AugmentFactory(_this5._def);
    return _this5;
  }

  _createClass(ZodObject, [{
    key: "_getCached",
    value: function _getCached() {
      if (this._cached !== null) return this._cached;

      var shape = this._def.shape();

      var keys = util_1.util.objectKeys(shape);
      return this._cached = {
        shape: shape,
        keys: keys
      };
    }
  }, {
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);

      if (parsedType !== parseUtil_1.ZodParsedType.object) {
        var _ctx4 = this._getOrReturnCtx(input);

        (0, parseUtil_1.addIssueToContext)(_ctx4, {
          code: ZodError_1.ZodIssueCode.invalid_type,
          expected: parseUtil_1.ZodParsedType.object,
          received: _ctx4.parsedType
        });
        return parseUtil_1.INVALID;
      }

      var _this$_processInputPa2 = this._processInputParams(input),
          status = _this$_processInputPa2.status,
          ctx = _this$_processInputPa2.ctx;

      var _this$_getCached = this._getCached(),
          shape = _this$_getCached.shape,
          shapeKeys = _this$_getCached.keys;

      var extraKeys = [];

      for (var key in ctx.data) {
        if (!shapeKeys.includes(key)) {
          extraKeys.push(key);
        }
      }

      var pairs = [];

      var _iterator5 = _createForOfIteratorHelper(shapeKeys),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _key4 = _step5.value;
          var keyValidator = shape[_key4];
          var _value = ctx.data[_key4];
          pairs.push({
            key: {
              status: "valid",
              value: _key4
            },
            value: keyValidator._parse(new ParseInputLazyPath(ctx, _value, ctx.path, _key4)),
            alwaysSet: _key4 in ctx.data
          });
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      if (this._def.catchall instanceof ZodNever) {
        var unknownKeys = this._def.unknownKeys;

        if (unknownKeys === "passthrough") {
          var _iterator6 = _createForOfIteratorHelper(extraKeys),
              _step6;

          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var _key = _step6.value;
              pairs.push({
                key: {
                  status: "valid",
                  value: _key
                },
                value: {
                  status: "valid",
                  value: ctx.data[_key]
                }
              });
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
        } else if (unknownKeys === "strict") {
          if (extraKeys.length > 0) {
            (0, parseUtil_1.addIssueToContext)(ctx, {
              code: ZodError_1.ZodIssueCode.unrecognized_keys,
              keys: extraKeys
            });
            status.dirty();
          }
        } else if (unknownKeys === "strip") {} else {
          throw new Error("Internal ZodObject error: invalid unknownKeys value.");
        }
      } else {
        // run catchall validation
        var catchall = this._def.catchall;

        var _iterator7 = _createForOfIteratorHelper(extraKeys),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _key2 = _step7.value;
            var value = ctx.data[_key2];
            pairs.push({
              key: {
                status: "valid",
                value: _key2
              },
              value: catchall._parse(new ParseInputLazyPath(ctx, value, ctx.path, _key2) //, ctx.child(key), value, getParsedType(value)
              ),
              alwaysSet: _key2 in ctx.data
            });
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      }

      if (ctx.common.async) {
        return Promise.resolve().then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          var syncPairs, _iterator8, _step8, pair, _key3;

          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  syncPairs = [];
                  _iterator8 = _createForOfIteratorHelper(pairs);
                  _context3.prev = 2;

                  _iterator8.s();

                case 4:
                  if ((_step8 = _iterator8.n()).done) {
                    _context3.next = 19;
                    break;
                  }

                  pair = _step8.value;
                  _context3.next = 8;
                  return pair.key;

                case 8:
                  _key3 = _context3.sent;
                  _context3.t0 = syncPairs;
                  _context3.t1 = _key3;
                  _context3.next = 13;
                  return pair.value;

                case 13:
                  _context3.t2 = _context3.sent;
                  _context3.t3 = pair.alwaysSet;
                  _context3.t4 = {
                    key: _context3.t1,
                    value: _context3.t2,
                    alwaysSet: _context3.t3
                  };

                  _context3.t0.push.call(_context3.t0, _context3.t4);

                case 17:
                  _context3.next = 4;
                  break;

                case 19:
                  _context3.next = 24;
                  break;

                case 21:
                  _context3.prev = 21;
                  _context3.t5 = _context3["catch"](2);

                  _iterator8.e(_context3.t5);

                case 24:
                  _context3.prev = 24;

                  _iterator8.f();

                  return _context3.finish(24);

                case 27:
                  return _context3.abrupt("return", syncPairs);

                case 28:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[2, 21, 24, 27]]);
        }))).then(function (syncPairs) {
          return parseUtil_1.ParseStatus.mergeObjectSync(status, syncPairs);
        });
      } else {
        return parseUtil_1.ParseStatus.mergeObjectSync(status, pairs);
      }
    }
  }, {
    key: "shape",
    get: function get() {
      return this._def.shape();
    }
  }, {
    key: "strict",
    value: function strict(message) {
      var _this6 = this;

      errorUtil_1.errorUtil.errToObj;
      return new ZodObject(_objectSpread(_objectSpread({}, this._def), {}, {
        unknownKeys: "strict"
      }, message !== undefined ? {
        errorMap: function errorMap(issue, ctx) {
          var _a, _b, _c, _d;

          var defaultError = (_c = (_b = (_a = _this6._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
          if (issue.code === "unrecognized_keys") return {
            message: (_d = errorUtil_1.errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
          };
          return {
            message: defaultError
          };
        }
      } : {}));
    }
  }, {
    key: "strip",
    value: function strip() {
      return new ZodObject(_objectSpread(_objectSpread({}, this._def), {}, {
        unknownKeys: "strip"
      }));
    }
  }, {
    key: "passthrough",
    value: function passthrough() {
      return new ZodObject(_objectSpread(_objectSpread({}, this._def), {}, {
        unknownKeys: "passthrough"
      }));
    }
  }, {
    key: "setKey",
    value: function setKey(key, schema) {
      return this.augment(_defineProperty({}, key, schema));
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */

  }, {
    key: "merge",
    value: function merge(merging) {
      var _this7 = this;

      // const mergedShape = objectUtil.mergeShapes(
      //   this._def.shape(),
      //   merging._def.shape()
      // );
      var merged = new ZodObject({
        unknownKeys: merging._def.unknownKeys,
        catchall: merging._def.catchall,
        shape: function shape() {
          return objectUtil.mergeShapes(_this7._def.shape(), merging._def.shape());
        },
        typeName: ZodFirstPartyTypeKind.ZodObject
      });
      return merged;
    }
  }, {
    key: "catchall",
    value: function catchall(index) {
      return new ZodObject(_objectSpread(_objectSpread({}, this._def), {}, {
        catchall: index
      }));
    }
  }, {
    key: "pick",
    value: function pick(mask) {
      var _this8 = this;

      var _shape = {};
      util_1.util.objectKeys(mask).map(function (key) {
        _shape[key] = _this8.shape[key];
      });
      return new ZodObject(_objectSpread(_objectSpread({}, this._def), {}, {
        shape: function shape() {
          return _shape;
        }
      }));
    }
  }, {
    key: "omit",
    value: function omit(mask) {
      var _this9 = this;

      var _shape2 = {};
      util_1.util.objectKeys(this.shape).map(function (key) {
        if (util_1.util.objectKeys(mask).indexOf(key) === -1) {
          _shape2[key] = _this9.shape[key];
        }
      });
      return new ZodObject(_objectSpread(_objectSpread({}, this._def), {}, {
        shape: function shape() {
          return _shape2;
        }
      }));
    }
  }, {
    key: "deepPartial",
    value: function deepPartial() {
      return deepPartialify(this);
    }
  }, {
    key: "partial",
    value: function partial(mask) {
      var _this10 = this;

      var newShape = {};

      if (mask) {
        util_1.util.objectKeys(this.shape).map(function (key) {
          if (util_1.util.objectKeys(mask).indexOf(key) === -1) {
            newShape[key] = _this10.shape[key];
          } else {
            newShape[key] = _this10.shape[key].optional();
          }
        });
        return new ZodObject(_objectSpread(_objectSpread({}, this._def), {}, {
          shape: function shape() {
            return newShape;
          }
        }));
      } else {
        for (var key in this.shape) {
          var fieldSchema = this.shape[key];
          newShape[key] = fieldSchema.optional();
        }
      }

      return new ZodObject(_objectSpread(_objectSpread({}, this._def), {}, {
        shape: function shape() {
          return newShape;
        }
      }));
    }
  }, {
    key: "required",
    value: function required() {
      var newShape = {};

      for (var key in this.shape) {
        var fieldSchema = this.shape[key];
        var newField = fieldSchema;

        while (newField instanceof ZodOptional) {
          newField = newField._def.innerType;
        }

        newShape[key] = newField;
      }

      return new ZodObject(_objectSpread(_objectSpread({}, this._def), {}, {
        shape: function shape() {
          return newShape;
        }
      }));
    }
  }]);

  return ZodObject;
}(ZodType);

exports.ZodObject = ZodObject;

ZodObject.create = function (_shape3, params) {
  return new ZodObject(_objectSpread({
    shape: function shape() {
      return _shape3;
    },
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject
  }, processCreateParams(params)));
};

ZodObject.strictCreate = function (_shape4, params) {
  return new ZodObject(_objectSpread({
    shape: function shape() {
      return _shape4;
    },
    unknownKeys: "strict",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject
  }, processCreateParams(params)));
};

ZodObject.lazycreate = function (shape, params) {
  return new ZodObject(_objectSpread({
    shape: shape,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject
  }, processCreateParams(params)));
};

var ZodUnion = /*#__PURE__*/function (_ZodType14) {
  _inherits(ZodUnion, _ZodType14);

  var _super14 = _createSuper(ZodUnion);

  function ZodUnion() {
    _classCallCheck(this, ZodUnion);

    return _super14.apply(this, arguments);
  }

  _createClass(ZodUnion, [{
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa3 = this._processInputParams(input),
          ctx = _this$_processInputPa3.ctx;

      var options = this._def.options;

      function handleResults(results) {
        // return first issue-free validation if it exists
        var _iterator9 = _createForOfIteratorHelper(results),
            _step9;

        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var result = _step9.value;

            if (result.result.status === "valid") {
              return result.result;
            }
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }

        var _iterator10 = _createForOfIteratorHelper(results),
            _step10;

        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var _result = _step10.value;

            if (_result.result.status === "dirty") {
              var _ctx$common$issues;

              // add issues from dirty option
              (_ctx$common$issues = ctx.common.issues).push.apply(_ctx$common$issues, _toConsumableArray(_result.ctx.common.issues));

              return _result.result;
            }
          } // return invalid

        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }

        var unionErrors = results.map(function (result) {
          return new ZodError_1.ZodError(result.ctx.common.issues);
        });
        (0, parseUtil_1.addIssueToContext)(ctx, {
          code: ZodError_1.ZodIssueCode.invalid_union,
          unionErrors: unionErrors
        });
        return parseUtil_1.INVALID;
      }

      if (ctx.common.async) {
        return Promise.all(options.map( /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(option) {
            var childCtx;
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    childCtx = _objectSpread(_objectSpread({}, ctx), {}, {
                      common: _objectSpread(_objectSpread({}, ctx.common), {}, {
                        issues: []
                      }),
                      parent: null
                    });
                    _context4.next = 3;
                    return option._parseAsync({
                      data: ctx.data,
                      path: ctx.path,
                      parent: childCtx
                    });

                  case 3:
                    _context4.t0 = _context4.sent;
                    _context4.t1 = childCtx;
                    return _context4.abrupt("return", {
                      result: _context4.t0,
                      ctx: _context4.t1
                    });

                  case 6:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }));

          return function (_x5) {
            return _ref2.apply(this, arguments);
          };
        }())).then(handleResults);
      } else {
        var dirty = undefined;
        var issues = [];

        var _iterator11 = _createForOfIteratorHelper(options),
            _step11;

        try {
          for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
            var option = _step11.value;

            var childCtx = _objectSpread(_objectSpread({}, ctx), {}, {
              common: _objectSpread(_objectSpread({}, ctx.common), {}, {
                issues: []
              }),
              parent: null
            });

            var result = option._parseSync({
              data: ctx.data,
              path: ctx.path,
              parent: childCtx
            });

            if (result.status === "valid") {
              return result;
            } else if (result.status === "dirty" && !dirty) {
              dirty = {
                result: result,
                ctx: childCtx
              };
            }

            if (childCtx.common.issues.length) {
              issues.push(childCtx.common.issues);
            }
          }
        } catch (err) {
          _iterator11.e(err);
        } finally {
          _iterator11.f();
        }

        if (dirty) {
          var _ctx$common$issues2;

          (_ctx$common$issues2 = ctx.common.issues).push.apply(_ctx$common$issues2, _toConsumableArray(dirty.ctx.common.issues));

          return dirty.result;
        }

        var unionErrors = issues.map(function (issues) {
          return new ZodError_1.ZodError(issues);
        });
        (0, parseUtil_1.addIssueToContext)(ctx, {
          code: ZodError_1.ZodIssueCode.invalid_union,
          unionErrors: unionErrors
        });
        return parseUtil_1.INVALID;
      }
    }
  }, {
    key: "options",
    get: function get() {
      return this._def.options;
    }
  }]);

  return ZodUnion;
}(ZodType);

exports.ZodUnion = ZodUnion;

ZodUnion.create = function (types, params) {
  return new ZodUnion(_objectSpread({
    options: types,
    typeName: ZodFirstPartyTypeKind.ZodUnion
  }, processCreateParams(params)));
};

var ZodDiscriminatedUnion = /*#__PURE__*/function (_ZodType15) {
  _inherits(ZodDiscriminatedUnion, _ZodType15);

  var _super15 = _createSuper(ZodDiscriminatedUnion);

  function ZodDiscriminatedUnion() {
    _classCallCheck(this, ZodDiscriminatedUnion);

    return _super15.apply(this, arguments);
  }

  _createClass(ZodDiscriminatedUnion, [{
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa4 = this._processInputParams(input),
          ctx = _this$_processInputPa4.ctx;

      if (ctx.parsedType !== parseUtil_1.ZodParsedType.object) {
        (0, parseUtil_1.addIssueToContext)(ctx, {
          code: ZodError_1.ZodIssueCode.invalid_type,
          expected: parseUtil_1.ZodParsedType.object,
          received: ctx.parsedType
        });
        return parseUtil_1.INVALID;
      }

      var discriminator = this.discriminator;
      var discriminatorValue = ctx.data[discriminator];
      var option = this.options.get(discriminatorValue);

      if (!option) {
        (0, parseUtil_1.addIssueToContext)(ctx, {
          code: ZodError_1.ZodIssueCode.invalid_union_discriminator,
          options: this.validDiscriminatorValues,
          path: [discriminator]
        });
        return parseUtil_1.INVALID;
      }

      if (ctx.common.async) {
        return option._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
      } else {
        return option._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
      }
    }
  }, {
    key: "discriminator",
    get: function get() {
      return this._def.discriminator;
    }
  }, {
    key: "validDiscriminatorValues",
    get: function get() {
      return Array.from(this.options.keys());
    }
  }, {
    key: "options",
    get: function get() {
      return this._def.options;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */

  }], [{
    key: "create",
    value: function create(discriminator, types, params) {
      // Get all the valid discriminator values
      var options = new Map();

      try {
        types.forEach(function (type) {
          var discriminatorValue = type.shape[discriminator].value;
          options.set(discriminatorValue, type);
        });
      } catch (e) {
        throw new Error("The discriminator value could not be extracted from all the provided schemas");
      } // Assert that all the discriminator values are unique


      if (options.size !== types.length) {
        throw new Error("Some of the discriminator values are not unique");
      }

      return new ZodDiscriminatedUnion(_objectSpread({
        typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
        discriminator: discriminator,
        options: options
      }, processCreateParams(params)));
    }
  }]);

  return ZodDiscriminatedUnion;
}(ZodType);

exports.ZodDiscriminatedUnion = ZodDiscriminatedUnion;

function mergeValues(a, b) {
  var aType = (0, parseUtil_1.getParsedType)(a);
  var bType = (0, parseUtil_1.getParsedType)(b);

  if (a === b) {
    return {
      valid: true,
      data: a
    };
  } else if (aType === parseUtil_1.ZodParsedType.object && bType === parseUtil_1.ZodParsedType.object) {
    var bKeys = util_1.util.objectKeys(b);
    var sharedKeys = util_1.util.objectKeys(a).filter(function (key) {
      return bKeys.indexOf(key) !== -1;
    });

    var newObj = _objectSpread(_objectSpread({}, a), b);

    var _iterator12 = _createForOfIteratorHelper(sharedKeys),
        _step12;

    try {
      for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
        var key = _step12.value;
        var sharedValue = mergeValues(a[key], b[key]);

        if (!sharedValue.valid) {
          return {
            valid: false
          };
        }

        newObj[key] = sharedValue.data;
      }
    } catch (err) {
      _iterator12.e(err);
    } finally {
      _iterator12.f();
    }

    return {
      valid: true,
      data: newObj
    };
  } else if (aType === parseUtil_1.ZodParsedType.array && bType === parseUtil_1.ZodParsedType.array) {
    if (a.length !== b.length) {
      return {
        valid: false
      };
    }

    var newArray = [];

    for (var index = 0; index < a.length; index++) {
      var itemA = a[index];
      var itemB = b[index];

      var _sharedValue = mergeValues(itemA, itemB);

      if (!_sharedValue.valid) {
        return {
          valid: false
        };
      }

      newArray.push(_sharedValue.data);
    }

    return {
      valid: true,
      data: newArray
    };
  } else if (aType === parseUtil_1.ZodParsedType.date && bType === parseUtil_1.ZodParsedType.date && +a === +b) {
    return {
      valid: true,
      data: a
    };
  } else {
    return {
      valid: false
    };
  }
}

var ZodIntersection = /*#__PURE__*/function (_ZodType16) {
  _inherits(ZodIntersection, _ZodType16);

  var _super16 = _createSuper(ZodIntersection);

  function ZodIntersection() {
    _classCallCheck(this, ZodIntersection);

    return _super16.apply(this, arguments);
  }

  _createClass(ZodIntersection, [{
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa5 = this._processInputParams(input),
          status = _this$_processInputPa5.status,
          ctx = _this$_processInputPa5.ctx;

      var handleParsed = function handleParsed(parsedLeft, parsedRight) {
        if ((0, parseUtil_1.isAborted)(parsedLeft) || (0, parseUtil_1.isAborted)(parsedRight)) {
          return parseUtil_1.INVALID;
        }

        var merged = mergeValues(parsedLeft.value, parsedRight.value);

        if (!merged.valid) {
          (0, parseUtil_1.addIssueToContext)(ctx, {
            code: ZodError_1.ZodIssueCode.invalid_intersection_types
          });
          return parseUtil_1.INVALID;
        }

        if ((0, parseUtil_1.isDirty)(parsedLeft) || (0, parseUtil_1.isDirty)(parsedRight)) {
          status.dirty();
        }

        return {
          status: status.value,
          value: merged.data
        };
      };

      if (ctx.common.async) {
        return Promise.all([this._def.left._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }), this._def.right._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        })]).then(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              left = _ref4[0],
              right = _ref4[1];

          return handleParsed(left, right);
        });
      } else {
        return handleParsed(this._def.left._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }), this._def.right._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }));
      }
    }
  }]);

  return ZodIntersection;
}(ZodType);

exports.ZodIntersection = ZodIntersection;

ZodIntersection.create = function (left, right, params) {
  return new ZodIntersection(_objectSpread({
    left: left,
    right: right,
    typeName: ZodFirstPartyTypeKind.ZodIntersection
  }, processCreateParams(params)));
};

var ZodTuple = /*#__PURE__*/function (_ZodType17) {
  _inherits(ZodTuple, _ZodType17);

  var _super17 = _createSuper(ZodTuple);

  function ZodTuple() {
    _classCallCheck(this, ZodTuple);

    return _super17.apply(this, arguments);
  }

  _createClass(ZodTuple, [{
    key: "_parse",
    value: function _parse(input) {
      var _this11 = this;

      var _this$_processInputPa6 = this._processInputParams(input),
          status = _this$_processInputPa6.status,
          ctx = _this$_processInputPa6.ctx;

      if (ctx.parsedType !== parseUtil_1.ZodParsedType.array) {
        (0, parseUtil_1.addIssueToContext)(ctx, {
          code: ZodError_1.ZodIssueCode.invalid_type,
          expected: parseUtil_1.ZodParsedType.array,
          received: ctx.parsedType
        });
        return parseUtil_1.INVALID;
      }

      if (ctx.data.length < this._def.items.length) {
        (0, parseUtil_1.addIssueToContext)(ctx, {
          code: ZodError_1.ZodIssueCode.too_small,
          minimum: this._def.items.length,
          inclusive: true,
          type: "array"
        });
        return parseUtil_1.INVALID;
      }

      var rest = this._def.rest;

      if (!rest && ctx.data.length > this._def.items.length) {
        (0, parseUtil_1.addIssueToContext)(ctx, {
          code: ZodError_1.ZodIssueCode.too_big,
          maximum: this._def.items.length,
          inclusive: true,
          type: "array"
        });
        status.dirty();
      }

      var items = ctx.data.map(function (item, itemIndex) {
        var schema = _this11._def.items[itemIndex] || _this11._def.rest;
        if (!schema) return null;
        return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
      }).filter(function (x) {
        return !!x;
      }); // filter nulls

      if (ctx.common.async) {
        return Promise.all(items).then(function (results) {
          return parseUtil_1.ParseStatus.mergeArray(status, results);
        });
      } else {
        return parseUtil_1.ParseStatus.mergeArray(status, items);
      }
    }
  }, {
    key: "items",
    get: function get() {
      return this._def.items;
    }
  }, {
    key: "rest",
    value: function rest(_rest) {
      return new ZodTuple(_objectSpread(_objectSpread({}, this._def), {}, {
        rest: _rest
      }));
    }
  }]);

  return ZodTuple;
}(ZodType);

exports.ZodTuple = ZodTuple;

ZodTuple.create = function (schemas, params) {
  return new ZodTuple(_objectSpread({
    items: schemas,
    typeName: ZodFirstPartyTypeKind.ZodTuple,
    rest: null
  }, processCreateParams(params)));
};

var ZodRecord = /*#__PURE__*/function (_ZodType18) {
  _inherits(ZodRecord, _ZodType18);

  var _super18 = _createSuper(ZodRecord);

  function ZodRecord() {
    _classCallCheck(this, ZodRecord);

    return _super18.apply(this, arguments);
  }

  _createClass(ZodRecord, [{
    key: "keySchema",
    get: function get() {
      return this._def.keyType;
    }
  }, {
    key: "valueSchema",
    get: function get() {
      return this._def.valueType;
    }
  }, {
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa7 = this._processInputParams(input),
          status = _this$_processInputPa7.status,
          ctx = _this$_processInputPa7.ctx;

      if (ctx.parsedType !== parseUtil_1.ZodParsedType.object) {
        (0, parseUtil_1.addIssueToContext)(ctx, {
          code: ZodError_1.ZodIssueCode.invalid_type,
          expected: parseUtil_1.ZodParsedType.object,
          received: ctx.parsedType
        });
        return parseUtil_1.INVALID;
      }

      var pairs = [];
      var keyType = this._def.keyType;
      var valueType = this._def.valueType;

      for (var key in ctx.data) {
        pairs.push({
          key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
          value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
        });
      }

      if (ctx.common.async) {
        return parseUtil_1.ParseStatus.mergeObjectAsync(status, pairs);
      } else {
        return parseUtil_1.ParseStatus.mergeObjectSync(status, pairs);
      }
    }
  }, {
    key: "element",
    get: function get() {
      return this._def.valueType;
    }
  }], [{
    key: "create",
    value: function create(first, second, third) {
      if (second instanceof ZodType) {
        return new ZodRecord(_objectSpread({
          keyType: first,
          valueType: second,
          typeName: ZodFirstPartyTypeKind.ZodRecord
        }, processCreateParams(third)));
      }

      return new ZodRecord(_objectSpread({
        keyType: ZodString.create(),
        valueType: first,
        typeName: ZodFirstPartyTypeKind.ZodRecord
      }, processCreateParams(second)));
    }
  }]);

  return ZodRecord;
}(ZodType);

exports.ZodRecord = ZodRecord;

var ZodMap = /*#__PURE__*/function (_ZodType19) {
  _inherits(ZodMap, _ZodType19);

  var _super19 = _createSuper(ZodMap);

  function ZodMap() {
    _classCallCheck(this, ZodMap);

    return _super19.apply(this, arguments);
  }

  _createClass(ZodMap, [{
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa8 = this._processInputParams(input),
          status = _this$_processInputPa8.status,
          ctx = _this$_processInputPa8.ctx;

      if (ctx.parsedType !== parseUtil_1.ZodParsedType.map) {
        (0, parseUtil_1.addIssueToContext)(ctx, {
          code: ZodError_1.ZodIssueCode.invalid_type,
          expected: parseUtil_1.ZodParsedType.map,
          received: ctx.parsedType
        });
        return parseUtil_1.INVALID;
      }

      var keyType = this._def.keyType;
      var valueType = this._def.valueType;

      var pairs = _toConsumableArray(ctx.data.entries()).map(function (_ref5, index) {
        var _ref6 = _slicedToArray(_ref5, 2),
            key = _ref6[0],
            value = _ref6[1];

        return {
          key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
          value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"]))
        };
      });

      if (ctx.common.async) {
        var finalMap = new Map();
        return Promise.resolve().then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
          var _iterator13, _step13, pair, key, value;

          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _iterator13 = _createForOfIteratorHelper(pairs);
                  _context5.prev = 1;

                  _iterator13.s();

                case 3:
                  if ((_step13 = _iterator13.n()).done) {
                    _context5.next = 17;
                    break;
                  }

                  pair = _step13.value;
                  _context5.next = 7;
                  return pair.key;

                case 7:
                  key = _context5.sent;
                  _context5.next = 10;
                  return pair.value;

                case 10:
                  value = _context5.sent;

                  if (!(key.status === "aborted" || value.status === "aborted")) {
                    _context5.next = 13;
                    break;
                  }

                  return _context5.abrupt("return", parseUtil_1.INVALID);

                case 13:
                  if (key.status === "dirty" || value.status === "dirty") {
                    status.dirty();
                  }

                  finalMap.set(key.value, value.value);

                case 15:
                  _context5.next = 3;
                  break;

                case 17:
                  _context5.next = 22;
                  break;

                case 19:
                  _context5.prev = 19;
                  _context5.t0 = _context5["catch"](1);

                  _iterator13.e(_context5.t0);

                case 22:
                  _context5.prev = 22;

                  _iterator13.f();

                  return _context5.finish(22);

                case 25:
                  return _context5.abrupt("return", {
                    status: status.value,
                    value: finalMap
                  });

                case 26:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, null, [[1, 19, 22, 25]]);
        })));
      } else {
        var _finalMap = new Map();

        var _iterator14 = _createForOfIteratorHelper(pairs),
            _step14;

        try {
          for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
            var pair = _step14.value;
            var key = pair.key;
            var value = pair.value;

            if (key.status === "aborted" || value.status === "aborted") {
              return parseUtil_1.INVALID;
            }

            if (key.status === "dirty" || value.status === "dirty") {
              status.dirty();
            }

            _finalMap.set(key.value, value.value);
          }
        } catch (err) {
          _iterator14.e(err);
        } finally {
          _iterator14.f();
        }

        return {
          status: status.value,
          value: _finalMap
        };
      }
    }
  }]);

  return ZodMap;
}(ZodType);

exports.ZodMap = ZodMap;

ZodMap.create = function (keyType, valueType, params) {
  return new ZodMap(_objectSpread({
    valueType: valueType,
    keyType: keyType,
    typeName: ZodFirstPartyTypeKind.ZodMap
  }, processCreateParams(params)));
};

var ZodSet = /*#__PURE__*/function (_ZodType20) {
  _inherits(ZodSet, _ZodType20);

  var _super20 = _createSuper(ZodSet);

  function ZodSet() {
    _classCallCheck(this, ZodSet);

    return _super20.apply(this, arguments);
  }

  _createClass(ZodSet, [{
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa9 = this._processInputParams(input),
          status = _this$_processInputPa9.status,
          ctx = _this$_processInputPa9.ctx;

      if (ctx.parsedType !== parseUtil_1.ZodParsedType.set) {
        (0, parseUtil_1.addIssueToContext)(ctx, {
          code: ZodError_1.ZodIssueCode.invalid_type,
          expected: parseUtil_1.ZodParsedType.set,
          received: ctx.parsedType
        });
        return parseUtil_1.INVALID;
      }

      var def = this._def;

      if (def.minSize !== null) {
        if (ctx.data.size < def.minSize.value) {
          (0, parseUtil_1.addIssueToContext)(ctx, {
            code: ZodError_1.ZodIssueCode.too_small,
            minimum: def.minSize.value,
            type: "set",
            inclusive: true,
            message: def.minSize.message
          });
          status.dirty();
        }
      }

      if (def.maxSize !== null) {
        if (ctx.data.size > def.maxSize.value) {
          (0, parseUtil_1.addIssueToContext)(ctx, {
            code: ZodError_1.ZodIssueCode.too_big,
            maximum: def.maxSize.value,
            type: "set",
            inclusive: true,
            message: def.maxSize.message
          });
          status.dirty();
        }
      }

      var valueType = this._def.valueType;

      function finalizeSet(elements) {
        var parsedSet = new Set();

        var _iterator15 = _createForOfIteratorHelper(elements),
            _step15;

        try {
          for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
            var element = _step15.value;
            if (element.status === "aborted") return parseUtil_1.INVALID;
            if (element.status === "dirty") status.dirty();
            parsedSet.add(element.value);
          }
        } catch (err) {
          _iterator15.e(err);
        } finally {
          _iterator15.f();
        }

        return {
          status: status.value,
          value: parsedSet
        };
      }

      var elements = _toConsumableArray(ctx.data.values()).map(function (item, i) {
        return valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i));
      });

      if (ctx.common.async) {
        return Promise.all(elements).then(function (elements) {
          return finalizeSet(elements);
        });
      } else {
        return finalizeSet(elements);
      }
    }
  }, {
    key: "min",
    value: function min(minSize, message) {
      return new ZodSet(_objectSpread(_objectSpread({}, this._def), {}, {
        minSize: {
          value: minSize,
          message: errorUtil_1.errorUtil.toString(message)
        }
      }));
    }
  }, {
    key: "max",
    value: function max(maxSize, message) {
      return new ZodSet(_objectSpread(_objectSpread({}, this._def), {}, {
        maxSize: {
          value: maxSize,
          message: errorUtil_1.errorUtil.toString(message)
        }
      }));
    }
  }, {
    key: "size",
    value: function size(_size, message) {
      return this.min(_size, message).max(_size, message);
    }
  }, {
    key: "nonempty",
    value: function nonempty(message) {
      return this.min(1, message);
    }
  }]);

  return ZodSet;
}(ZodType);

exports.ZodSet = ZodSet;

ZodSet.create = function (valueType, params) {
  return new ZodSet(_objectSpread({
    valueType: valueType,
    minSize: null,
    maxSize: null,
    typeName: ZodFirstPartyTypeKind.ZodSet
  }, processCreateParams(params)));
};

var ZodFunction = /*#__PURE__*/function (_ZodType21) {
  _inherits(ZodFunction, _ZodType21);

  var _super21 = _createSuper(ZodFunction);

  function ZodFunction() {
    var _this12;

    _classCallCheck(this, ZodFunction);

    _this12 = _super21.apply(this, arguments);
    _this12.validate = _this12.implement;
    return _this12;
  }

  _createClass(ZodFunction, [{
    key: "_parse",
    value: function _parse(input) {
      var _this13 = this;

      var _this$_processInputPa10 = this._processInputParams(input),
          ctx = _this$_processInputPa10.ctx;

      if (ctx.parsedType !== parseUtil_1.ZodParsedType.function) {
        (0, parseUtil_1.addIssueToContext)(ctx, {
          code: ZodError_1.ZodIssueCode.invalid_type,
          expected: parseUtil_1.ZodParsedType.function,
          received: ctx.parsedType
        });
        return parseUtil_1.INVALID;
      }

      function makeArgsIssue(args, error) {
        return (0, parseUtil_1.makeIssue)({
          data: args,
          path: ctx.path,
          errorMaps: [ctx.common.contextualErrorMap, ctx.schemaErrorMap, ZodError_1.overrideErrorMap, ZodError_1.defaultErrorMap].filter(function (x) {
            return !!x;
          }),
          issueData: {
            code: ZodError_1.ZodIssueCode.invalid_arguments,
            argumentsError: error
          }
        });
      }

      function makeReturnsIssue(returns, error) {
        return (0, parseUtil_1.makeIssue)({
          data: returns,
          path: ctx.path,
          errorMaps: [ctx.common.contextualErrorMap, ctx.schemaErrorMap, ZodError_1.overrideErrorMap, ZodError_1.defaultErrorMap].filter(function (x) {
            return !!x;
          }),
          issueData: {
            code: ZodError_1.ZodIssueCode.invalid_return_type,
            returnTypeError: error
          }
        });
      }

      var params = {
        errorMap: ctx.common.contextualErrorMap
      };
      var fn = ctx.data;

      if (this._def.returns instanceof ZodPromise) {
        return (0, parseUtil_1.OK)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
          var _len,
              args,
              _key5,
              error,
              parsedArgs,
              result,
              parsedReturns,
              _args6 = arguments;

          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  for (_len = _args6.length, args = new Array(_len), _key5 = 0; _key5 < _len; _key5++) {
                    args[_key5] = _args6[_key5];
                  }

                  error = new ZodError_1.ZodError([]);
                  _context6.next = 4;
                  return _this13._def.args.parseAsync(args, params).catch(function (e) {
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                  });

                case 4:
                  parsedArgs = _context6.sent;
                  _context6.next = 7;
                  return fn.apply(void 0, _toConsumableArray(parsedArgs));

                case 7:
                  result = _context6.sent;
                  _context6.next = 10;
                  return _this13._def.returns._def.type.parseAsync(result, params).catch(function (e) {
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                  });

                case 10:
                  parsedReturns = _context6.sent;
                  return _context6.abrupt("return", parsedReturns);

                case 12:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        })));
      } else {
        return (0, parseUtil_1.OK)(function () {
          for (var _len2 = arguments.length, args = new Array(_len2), _key6 = 0; _key6 < _len2; _key6++) {
            args[_key6] = arguments[_key6];
          }

          var parsedArgs = _this13._def.args.safeParse(args, params);

          if (!parsedArgs.success) {
            throw new ZodError_1.ZodError([makeArgsIssue(args, parsedArgs.error)]);
          }

          var result = fn.apply(void 0, _toConsumableArray(parsedArgs.data));

          var parsedReturns = _this13._def.returns.safeParse(result, params);

          if (!parsedReturns.success) {
            throw new ZodError_1.ZodError([makeReturnsIssue(result, parsedReturns.error)]);
          }

          return parsedReturns.data;
        });
      }
    }
  }, {
    key: "parameters",
    value: function parameters() {
      return this._def.args;
    }
  }, {
    key: "returnType",
    value: function returnType() {
      return this._def.returns;
    }
  }, {
    key: "args",
    value: function args() {
      for (var _len3 = arguments.length, items = new Array(_len3), _key7 = 0; _key7 < _len3; _key7++) {
        items[_key7] = arguments[_key7];
      }

      return new ZodFunction(_objectSpread(_objectSpread({}, this._def), {}, {
        args: ZodTuple.create(items).rest(ZodUnknown.create())
      }));
    }
  }, {
    key: "returns",
    value: function returns(returnType) {
      return new ZodFunction(_objectSpread(_objectSpread({}, this._def), {}, {
        returns: returnType
      }));
    }
  }, {
    key: "implement",
    value: function implement(func) {
      var validatedFunc = this.parse(func);
      return validatedFunc;
    }
  }, {
    key: "strictImplement",
    value: function strictImplement(func) {
      var validatedFunc = this.parse(func);
      return validatedFunc;
    }
  }]);

  return ZodFunction;
}(ZodType);

exports.ZodFunction = ZodFunction;

ZodFunction.create = function (args, returns, params) {
  return new ZodFunction(_objectSpread({
    args: args ? args.rest(ZodUnknown.create()) : ZodTuple.create([]).rest(ZodUnknown.create()),
    returns: returns || ZodUnknown.create(),
    typeName: ZodFirstPartyTypeKind.ZodFunction
  }, processCreateParams(params)));
};

var ZodLazy = /*#__PURE__*/function (_ZodType22) {
  _inherits(ZodLazy, _ZodType22);

  var _super22 = _createSuper(ZodLazy);

  function ZodLazy() {
    _classCallCheck(this, ZodLazy);

    return _super22.apply(this, arguments);
  }

  _createClass(ZodLazy, [{
    key: "schema",
    get: function get() {
      return this._def.getter();
    }
  }, {
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa11 = this._processInputParams(input),
          ctx = _this$_processInputPa11.ctx;

      var lazySchema = this._def.getter();

      return lazySchema._parse({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    }
  }]);

  return ZodLazy;
}(ZodType);

exports.ZodLazy = ZodLazy;

ZodLazy.create = function (getter, params) {
  return new ZodLazy(_objectSpread({
    getter: getter,
    typeName: ZodFirstPartyTypeKind.ZodLazy
  }, processCreateParams(params)));
};

var ZodLiteral = /*#__PURE__*/function (_ZodType23) {
  _inherits(ZodLiteral, _ZodType23);

  var _super23 = _createSuper(ZodLiteral);

  function ZodLiteral() {
    _classCallCheck(this, ZodLiteral);

    return _super23.apply(this, arguments);
  }

  _createClass(ZodLiteral, [{
    key: "_parse",
    value: function _parse(input) {
      if (input.data !== this._def.value) {
        var ctx = this._getOrReturnCtx(input);

        (0, parseUtil_1.addIssueToContext)(ctx, {
          code: ZodError_1.ZodIssueCode.invalid_literal,
          expected: this._def.value
        });
        return parseUtil_1.INVALID;
      }

      return {
        status: "valid",
        value: input.data
      };
    }
  }, {
    key: "value",
    get: function get() {
      return this._def.value;
    }
  }]);

  return ZodLiteral;
}(ZodType);

exports.ZodLiteral = ZodLiteral;

ZodLiteral.create = function (value, params) {
  return new ZodLiteral(_objectSpread({
    value: value,
    typeName: ZodFirstPartyTypeKind.ZodLiteral
  }, processCreateParams(params)));
};

function createZodEnum(values) {
  return new ZodEnum({
    values: values,
    typeName: ZodFirstPartyTypeKind.ZodEnum
  });
}

var ZodEnum = /*#__PURE__*/function (_ZodType24) {
  _inherits(ZodEnum, _ZodType24);

  var _super24 = _createSuper(ZodEnum);

  function ZodEnum() {
    _classCallCheck(this, ZodEnum);

    return _super24.apply(this, arguments);
  }

  _createClass(ZodEnum, [{
    key: "_parse",
    value: function _parse(input) {
      if (this._def.values.indexOf(input.data) === -1) {
        var ctx = this._getOrReturnCtx(input);

        (0, parseUtil_1.addIssueToContext)(ctx, {
          code: ZodError_1.ZodIssueCode.invalid_enum_value,
          options: this._def.values
        });
        return parseUtil_1.INVALID;
      }

      return (0, parseUtil_1.OK)(input.data);
    }
  }, {
    key: "options",
    get: function get() {
      return this._def.values;
    }
  }, {
    key: "enum",
    get: function get() {
      var enumValues = {};

      var _iterator16 = _createForOfIteratorHelper(this._def.values),
          _step16;

      try {
        for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
          var val = _step16.value;
          enumValues[val] = val;
        }
      } catch (err) {
        _iterator16.e(err);
      } finally {
        _iterator16.f();
      }

      return enumValues;
    }
  }, {
    key: "Values",
    get: function get() {
      var enumValues = {};

      var _iterator17 = _createForOfIteratorHelper(this._def.values),
          _step17;

      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var val = _step17.value;
          enumValues[val] = val;
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }

      return enumValues;
    }
  }, {
    key: "Enum",
    get: function get() {
      var enumValues = {};

      var _iterator18 = _createForOfIteratorHelper(this._def.values),
          _step18;

      try {
        for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
          var val = _step18.value;
          enumValues[val] = val;
        }
      } catch (err) {
        _iterator18.e(err);
      } finally {
        _iterator18.f();
      }

      return enumValues;
    }
  }]);

  return ZodEnum;
}(ZodType);

exports.ZodEnum = ZodEnum;
ZodEnum.create = createZodEnum;

var ZodNativeEnum = /*#__PURE__*/function (_ZodType25) {
  _inherits(ZodNativeEnum, _ZodType25);

  var _super25 = _createSuper(ZodNativeEnum);

  function ZodNativeEnum() {
    _classCallCheck(this, ZodNativeEnum);

    return _super25.apply(this, arguments);
  }

  _createClass(ZodNativeEnum, [{
    key: "_parse",
    value: function _parse(input) {
      var nativeEnumValues = util_1.util.getValidEnumValues(this._def.values);

      if (nativeEnumValues.indexOf(input.data) === -1) {
        var ctx = this._getOrReturnCtx(input);

        (0, parseUtil_1.addIssueToContext)(ctx, {
          code: ZodError_1.ZodIssueCode.invalid_enum_value,
          options: util_1.util.objectValues(nativeEnumValues)
        });
        return parseUtil_1.INVALID;
      }

      return (0, parseUtil_1.OK)(input.data);
    }
  }, {
    key: "enum",
    get: function get() {
      return this._def.values;
    }
  }]);

  return ZodNativeEnum;
}(ZodType);

exports.ZodNativeEnum = ZodNativeEnum;

ZodNativeEnum.create = function (values, params) {
  return new ZodNativeEnum(_objectSpread({
    values: values,
    typeName: ZodFirstPartyTypeKind.ZodNativeEnum
  }, processCreateParams(params)));
};

var ZodPromise = /*#__PURE__*/function (_ZodType26) {
  _inherits(ZodPromise, _ZodType26);

  var _super26 = _createSuper(ZodPromise);

  function ZodPromise() {
    _classCallCheck(this, ZodPromise);

    return _super26.apply(this, arguments);
  }

  _createClass(ZodPromise, [{
    key: "_parse",
    value: function _parse(input) {
      var _this14 = this;

      var _this$_processInputPa12 = this._processInputParams(input),
          ctx = _this$_processInputPa12.ctx;

      if (ctx.parsedType !== parseUtil_1.ZodParsedType.promise && ctx.common.async === false) {
        (0, parseUtil_1.addIssueToContext)(ctx, {
          code: ZodError_1.ZodIssueCode.invalid_type,
          expected: parseUtil_1.ZodParsedType.promise,
          received: ctx.parsedType
        });
        return parseUtil_1.INVALID;
      }

      var promisified = ctx.parsedType === parseUtil_1.ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
      return (0, parseUtil_1.OK)(promisified.then(function (data) {
        return _this14._def.type.parseAsync(data, {
          path: ctx.path,
          errorMap: ctx.common.contextualErrorMap
        });
      }));
    }
  }]);

  return ZodPromise;
}(ZodType);

exports.ZodPromise = ZodPromise;

ZodPromise.create = function (schema, params) {
  return new ZodPromise(_objectSpread({
    type: schema,
    typeName: ZodFirstPartyTypeKind.ZodPromise
  }, processCreateParams(params)));
};

var ZodEffects = /*#__PURE__*/function (_ZodType27) {
  _inherits(ZodEffects, _ZodType27);

  var _super27 = _createSuper(ZodEffects);

  function ZodEffects() {
    _classCallCheck(this, ZodEffects);

    return _super27.apply(this, arguments);
  }

  _createClass(ZodEffects, [{
    key: "innerType",
    value: function innerType() {
      return this._def.schema;
    }
  }, {
    key: "_parse",
    value: function _parse(input) {
      var _this15 = this;

      var _this$_processInputPa13 = this._processInputParams(input),
          status = _this$_processInputPa13.status,
          ctx = _this$_processInputPa13.ctx;

      var effect = this._def.effect || null;

      if (effect.type === "preprocess") {
        var processed = effect.transform(ctx.data);

        if (ctx.common.async) {
          return Promise.resolve(processed).then(function (processed) {
            return _this15._def.schema._parseAsync({
              data: processed,
              path: ctx.path,
              parent: ctx
            });
          });
        } else {
          return this._def.schema._parseSync({
            data: processed,
            path: ctx.path,
            parent: ctx
          });
        }
      }

      if (effect.type === "refinement") {
        var checkCtx = {
          addIssue: function addIssue(arg) {
            (0, parseUtil_1.addIssueToContext)(ctx, arg);

            if (arg.fatal) {
              status.abort();
            } else {
              status.dirty();
            }
          },

          get path() {
            return ctx.path;
          }

        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);

        var executeRefinement = function executeRefinement(acc // effect: RefinementEffect<any>
        ) {
          var result = effect.refinement(acc, checkCtx);

          if (ctx.common.async) {
            return Promise.resolve(result);
          }

          if (result instanceof Promise) {
            throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
          }

          return acc;
        };

        if (ctx.common.async === false) {
          var inner = this._def.schema._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          });

          if (inner.status === "aborted") return parseUtil_1.INVALID;
          if (inner.status === "dirty") status.dirty(); // return value is ignored

          executeRefinement(inner.value);
          return {
            status: status.value,
            value: inner.value
          };
        } else {
          return this._def.schema._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          }).then(function (inner) {
            if (inner.status === "aborted") return parseUtil_1.INVALID;
            if (inner.status === "dirty") status.dirty();
            return executeRefinement(inner.value).then(function () {
              return {
                status: status.value,
                value: inner.value
              };
            });
          });
        }
      }

      if (effect.type === "transform") {
        if (ctx.common.async === false) {
          var base = this._def.schema._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          }); // if (base.status === "aborted") return INVALID;
          // if (base.status === "dirty") {
          //   return { status: "dirty", value: base.value };
          // }


          if (!(0, parseUtil_1.isValid)(base)) return base;
          var result = effect.transform(base.value);

          if (result instanceof Promise) {
            throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
          }

          return (0, parseUtil_1.OK)(result);
        } else {
          return this._def.schema._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          }).then(function (base) {
            if (!(0, parseUtil_1.isValid)(base)) return base; // if (base.status === "aborted") return INVALID;
            // if (base.status === "dirty") {
            //   return { status: "dirty", value: base.value };
            // }

            return Promise.resolve(effect.transform(base.value)).then(parseUtil_1.OK);
          });
        }
      }

      util_1.util.assertNever(effect);
    }
  }]);

  return ZodEffects;
}(ZodType);

exports.ZodEffects = ZodEffects;
exports.ZodTransformer = ZodEffects;

ZodEffects.create = function (schema, effect, params) {
  return new ZodEffects(_objectSpread({
    schema: schema,
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    effect: effect
  }, processCreateParams(params)));
};

ZodEffects.createWithPreprocess = function (preprocess, schema, params) {
  return new ZodEffects(_objectSpread({
    schema: schema,
    effect: {
      type: "preprocess",
      transform: preprocess
    },
    typeName: ZodFirstPartyTypeKind.ZodEffects
  }, processCreateParams(params)));
};

var ZodOptional = /*#__PURE__*/function (_ZodType28) {
  _inherits(ZodOptional, _ZodType28);

  var _super28 = _createSuper(ZodOptional);

  function ZodOptional() {
    _classCallCheck(this, ZodOptional);

    return _super28.apply(this, arguments);
  }

  _createClass(ZodOptional, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);

      if (parsedType === parseUtil_1.ZodParsedType.undefined) {
        return (0, parseUtil_1.OK)(undefined);
      }

      return this._def.innerType._parse(input);
    }
  }, {
    key: "unwrap",
    value: function unwrap() {
      return this._def.innerType;
    }
  }]);

  return ZodOptional;
}(ZodType);

exports.ZodOptional = ZodOptional;

ZodOptional.create = function (type, params) {
  return new ZodOptional(_objectSpread({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodOptional
  }, processCreateParams(params)));
};

var ZodNullable = /*#__PURE__*/function (_ZodType29) {
  _inherits(ZodNullable, _ZodType29);

  var _super29 = _createSuper(ZodNullable);

  function ZodNullable() {
    _classCallCheck(this, ZodNullable);

    return _super29.apply(this, arguments);
  }

  _createClass(ZodNullable, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);

      if (parsedType === parseUtil_1.ZodParsedType.null) {
        return (0, parseUtil_1.OK)(null);
      }

      return this._def.innerType._parse(input);
    }
  }, {
    key: "unwrap",
    value: function unwrap() {
      return this._def.innerType;
    }
  }]);

  return ZodNullable;
}(ZodType);

exports.ZodNullable = ZodNullable;

ZodNullable.create = function (type, params) {
  return new ZodNullable(_objectSpread({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodNullable
  }, processCreateParams(params)));
};

var ZodDefault = /*#__PURE__*/function (_ZodType30) {
  _inherits(ZodDefault, _ZodType30);

  var _super30 = _createSuper(ZodDefault);

  function ZodDefault() {
    _classCallCheck(this, ZodDefault);

    return _super30.apply(this, arguments);
  }

  _createClass(ZodDefault, [{
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa14 = this._processInputParams(input),
          ctx = _this$_processInputPa14.ctx;

      var data = ctx.data;

      if (ctx.parsedType === parseUtil_1.ZodParsedType.undefined) {
        data = this._def.defaultValue();
      }

      return this._def.innerType._parse({
        data: data,
        path: ctx.path,
        parent: ctx
      });
    }
  }, {
    key: "removeDefault",
    value: function removeDefault() {
      return this._def.innerType;
    }
  }]);

  return ZodDefault;
}(ZodType);

exports.ZodDefault = ZodDefault;

ZodDefault.create = function (type, params) {
  return new ZodOptional(_objectSpread({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodOptional
  }, processCreateParams(params)));
};

var ZodNaN = /*#__PURE__*/function (_ZodType31) {
  _inherits(ZodNaN, _ZodType31);

  var _super31 = _createSuper(ZodNaN);

  function ZodNaN() {
    _classCallCheck(this, ZodNaN);

    return _super31.apply(this, arguments);
  }

  _createClass(ZodNaN, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);

      if (parsedType !== parseUtil_1.ZodParsedType.nan) {
        var ctx = this._getOrReturnCtx(input);

        (0, parseUtil_1.addIssueToContext)(ctx, {
          code: ZodError_1.ZodIssueCode.invalid_type,
          expected: parseUtil_1.ZodParsedType.nan,
          received: ctx.parsedType
        });
        return parseUtil_1.INVALID;
      }

      return {
        status: "valid",
        value: input.data
      };
    }
  }]);

  return ZodNaN;
}(ZodType);

exports.ZodNaN = ZodNaN;

ZodNaN.create = function (params) {
  return new ZodNaN(_objectSpread({
    typeName: ZodFirstPartyTypeKind.ZodNaN
  }, processCreateParams(params)));
};

var custom = function custom(check, params) {
  if (check) return ZodAny.create().refine(check, params);
  return ZodAny.create();
};

exports.custom = custom;
exports.late = {
  object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;

(function (ZodFirstPartyTypeKind) {
  ZodFirstPartyTypeKind["ZodString"] = "ZodString";
  ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
  ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
  ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
  ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
  ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
  ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
  ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
  ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
  ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
  ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
  ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
  ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
  ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
  ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
  ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
  ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
  ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
  ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
  ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
  ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
  ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
  ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
  ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
  ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
  ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
  ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
  ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
  ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
  ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
  ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
})(ZodFirstPartyTypeKind = exports.ZodFirstPartyTypeKind || (exports.ZodFirstPartyTypeKind = {}));

var instanceOfType = function instanceOfType(cls) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    message: "Input not instance of ".concat(cls.name)
  };
  return (0, exports.custom)(function (data) {
    return data instanceof cls;
  }, params);
};

exports.instanceof = instanceOfType;
var stringType = ZodString.create;
exports.string = stringType;
var numberType = ZodNumber.create;
exports.number = numberType;
var nanType = ZodNaN.create;
exports.nan = nanType;
var bigIntType = ZodBigInt.create;
exports.bigint = bigIntType;
var booleanType = ZodBoolean.create;
exports.boolean = booleanType;
var dateType = ZodDate.create;
exports.date = dateType;
var undefinedType = ZodUndefined.create;
exports.undefined = undefinedType;
var nullType = ZodNull.create;
exports.null = nullType;
var anyType = ZodAny.create;
exports.any = anyType;
var unknownType = ZodUnknown.create;
exports.unknown = unknownType;
var neverType = ZodNever.create;
exports.never = neverType;
var voidType = ZodVoid.create;
exports.void = voidType;
var arrayType = ZodArray.create;
exports.array = arrayType;
var objectType = ZodObject.create;
exports.object = objectType;
var strictObjectType = ZodObject.strictCreate;
exports.strictObject = strictObjectType;
var unionType = ZodUnion.create;
exports.union = unionType;
var discriminatedUnionType = ZodDiscriminatedUnion.create;
exports.discriminatedUnion = discriminatedUnionType;
var intersectionType = ZodIntersection.create;
exports.intersection = intersectionType;
var tupleType = ZodTuple.create;
exports.tuple = tupleType;
var recordType = ZodRecord.create;
exports.record = recordType;
var mapType = ZodMap.create;
exports.map = mapType;
var setType = ZodSet.create;
exports.set = setType;
var functionType = ZodFunction.create;
exports.function = functionType;
var lazyType = ZodLazy.create;
exports.lazy = lazyType;
var literalType = ZodLiteral.create;
exports.literal = literalType;
var enumType = ZodEnum.create;
exports.enum = enumType;
var nativeEnumType = ZodNativeEnum.create;
exports.nativeEnum = nativeEnumType;
var promiseType = ZodPromise.create;
exports.promise = promiseType;
var effectsType = ZodEffects.create;
exports.effect = effectsType;
exports.transformer = effectsType;
var optionalType = ZodOptional.create;
exports.optional = optionalType;
var nullableType = ZodNullable.create;
exports.nullable = nullableType;
var preprocessType = ZodEffects.createWithPreprocess;
exports.preprocess = preprocessType;

var ostring = function ostring() {
  return stringType().optional();
};

exports.ostring = ostring;

var onumber = function onumber() {
  return numberType().optional();
};

exports.onumber = onumber;

var oboolean = function oboolean() {
  return booleanType().optional();
};

exports.oboolean = oboolean;